var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoHrBlueTr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1350,
    height: 877.607,
    viewBox: "0 0 1350 877.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,877.607)",
    d: "M0 877.607H1350V0H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,223.0735,476.00129)",
    d: "M0 0C-.13-.193-.372-.404-.726-.629-1.081-.856-1.421-.968-1.742-.968H-30.01C-30.722-.968-31.252-.677-31.607-.097-31.962 .484-31.979 1.129-31.656 1.839L8.036 74.155C8.163 74.412 8.406 74.639 8.761 74.833 9.115 75.027 9.422 75.124 9.681 75.124H39.498C39.82 75.124 40.142 75.027 40.466 74.833 40.788 74.639 41.014 74.412 41.144 74.155L80.351 1.839C80.738 1.129 80.738 .484 80.351-.097 79.964-.677 79.415-.968 78.705-.968H50.825C50.501-.968 50.179-.856 49.856-.629 49.533-.404 49.307-.193 49.178 0L43.37 10.843H12.779C12.068 10.843 11.536 11.133 11.181 11.714 10.826 12.295 10.843 12.908 11.23 13.553L20.813 31.85C20.942 32.107 21.168 32.317 21.491 32.479 21.814 32.64 22.104 32.722 22.363 32.722H31.656L28.268 39.207H28.365C27.913 39.982 27.557 40.611 27.3 41.095 27.041 41.579 26.783 42.03 26.526 42.45 26.267 42.87 25.977 43.37 25.654 43.951 25.331 44.532 24.912 45.307 24.395 46.275Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,223.0735,476.00129)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C-.13-.193-.372-.404-.726-.629-1.081-.856-1.421-.968-1.742-.968H-30.01C-30.722-.968-31.252-.677-31.607-.097-31.962 .484-31.979 1.129-31.656 1.839L8.036 74.155C8.163 74.412 8.406 74.639 8.761 74.833 9.115 75.027 9.422 75.124 9.681 75.124H39.498C39.82 75.124 40.142 75.027 40.466 74.833 40.788 74.639 41.014 74.412 41.144 74.155L80.351 1.839C80.738 1.129 80.738 .484 80.351-.097 79.964-.677 79.415-.968 78.705-.968H50.825C50.501-.968 50.179-.856 49.856-.629 49.533-.404 49.307-.193 49.178 0L43.37 10.843H12.779C12.068 10.843 11.536 11.133 11.181 11.714 10.826 12.295 10.843 12.908 11.23 13.553L20.813 31.85C20.942 32.107 21.168 32.317 21.491 32.479 21.814 32.64 22.104 32.722 22.363 32.722H31.656L28.268 39.207H28.365C27.913 39.982 27.557 40.611 27.3 41.095 27.041 41.579 26.783 42.03 26.526 42.45 26.267 42.87 25.977 43.37 25.654 43.951 25.331 44.532 24.912 45.307 24.395 46.275L0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,343.179,432.5341)",
    d: "M0 0H28.074C29.364 0 30.478 .339 31.414 1.016 32.349 1.694 32.849 2.646 32.914 3.872 32.722 4.775 32.189 5.55 31.317 6.196 30.446 6.84 29.461 7.164 28.365 7.164H0ZM15.005-22.46 0-9.003V-42.596C0-43.113-.179-43.549-.532-43.903-.888-44.258-1.324-44.435-1.84-44.435H-26.816C-27.333-44.435-27.769-44.258-28.123-43.903-28.479-43.549-28.655-43.113-28.655-42.596V29.817C-28.655 30.333-28.479 30.768-28.123 31.124-27.769 31.478-27.333 31.656-26.816 31.656H30.204C35.495 31.656 40.014 31.269 43.757 30.494 47.499 29.72 50.566 28.38 52.954 26.477 55.341 24.573 57.083 22.007 58.181 18.781 59.279 15.553 59.828 11.487 59.828 6.583 59.828 1.612 59.375-2.695 58.472-6.341 57.567-9.988 56.101-13.006 54.067-15.392 52.035-17.781 49.404-19.555 46.177-20.717 42.95-21.879 39.014-22.46 34.367-22.46Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,343.179,432.5341)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0H28.074C29.364 0 30.478 .339 31.414 1.016 32.349 1.694 32.849 2.646 32.914 3.872 32.722 4.775 32.189 5.55 31.317 6.196 30.446 6.84 29.461 7.164 28.365 7.164H0V0ZM15.005-22.46 0-9.003V-42.596C0-43.113-.179-43.549-.532-43.903-.888-44.258-1.324-44.435-1.84-44.435H-26.816C-27.333-44.435-27.769-44.258-28.123-43.903-28.479-43.549-28.655-43.113-28.655-42.596V29.817C-28.655 30.333-28.479 30.768-28.123 31.124-27.769 31.478-27.333 31.656-26.816 31.656H30.204C35.495 31.656 40.014 31.269 43.757 30.494 47.499 29.72 50.566 28.38 52.954 26.477 55.341 24.573 57.083 22.007 58.181 18.781 59.279 15.553 59.828 11.487 59.828 6.583 59.828 1.612 59.375-2.695 58.472-6.341 57.567-9.988 56.101-13.006 54.067-15.392 52.035-17.781 49.404-19.555 46.177-20.717 42.95-21.879 39.014-22.46 34.367-22.46H15.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,423.804,476.00129)",
    d: "M0 0C-.13-.193-.372-.404-.726-.629-1.081-.856-1.421-.968-1.742-.968H-30.01C-30.722-.968-31.252-.677-31.608-.097-31.962 .484-31.979 1.129-31.656 1.839L8.036 74.155C8.163 74.412 8.406 74.639 8.761 74.833 9.115 75.027 9.422 75.124 9.681 75.124H39.498C39.82 75.124 40.142 75.027 40.466 74.833 40.788 74.639 41.014 74.412 41.144 74.155L80.351 1.839C80.738 1.129 80.738 .484 80.351-.097 79.964-.677 79.415-.968 78.705-.968H50.825C50.501-.968 50.179-.856 49.856-.629 49.533-.404 49.307-.193 49.178 0L43.37 10.843H12.779C12.068 10.843 11.536 11.133 11.181 11.714 10.826 12.295 10.843 12.908 11.23 13.553L20.813 31.85C20.942 32.107 21.168 32.317 21.491 32.479 21.814 32.64 22.104 32.722 22.363 32.722H31.656L28.268 39.207H28.365C27.913 39.982 27.557 40.611 27.3 41.095 27.041 41.579 26.783 42.03 26.526 42.45 26.267 42.87 25.977 43.37 25.654 43.951 25.331 44.532 24.912 45.307 24.395 46.275Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,423.804,476.00129)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C-.13-.193-.372-.404-.726-.629-1.081-.856-1.421-.968-1.742-.968H-30.01C-30.722-.968-31.252-.677-31.608-.097-31.962 .484-31.979 1.129-31.656 1.839L8.036 74.155C8.163 74.412 8.406 74.639 8.761 74.833 9.115 75.027 9.422 75.124 9.681 75.124H39.498C39.82 75.124 40.142 75.027 40.466 74.833 40.788 74.639 41.014 74.412 41.144 74.155L80.351 1.839C80.738 1.129 80.738 .484 80.351-.097 79.964-.677 79.415-.968 78.705-.968H50.825C50.501-.968 50.179-.856 49.856-.629 49.533-.404 49.307-.193 49.178 0L43.37 10.843H12.779C12.068 10.843 11.536 11.133 11.181 11.714 10.826 12.295 10.843 12.908 11.23 13.553L20.813 31.85C20.942 32.107 21.168 32.317 21.491 32.479 21.814 32.64 22.104 32.722 22.363 32.722H31.656L28.268 39.207H28.365C27.913 39.982 27.557 40.611 27.3 41.095 27.041 41.579 26.783 42.03 26.526 42.45 26.267 42.87 25.977 43.37 25.654 43.951 25.331 44.532 24.912 45.307 24.395 46.275L0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,542.1614,453.2512)",
    d: "M0 0H60.989C61.44 0 61.892-.162 62.344-.484 62.667-.936 62.829-1.389 62.829-1.839V-21.879C62.829-22.331 62.667-22.783 62.344-23.234 61.892-23.558 61.44-23.718 60.989-23.718H.097C-8.94-23.718-15.489-21.815-19.555-18.007-21.751-16.135-23.364-13.78-24.396-10.939-25.429-8.1-25.945-4.84-25.945-1.162V29.623C-25.945 37.238-23.815 42.886-19.555 46.565-15.489 50.372-8.94 52.277 .097 52.277H60.989C61.57 52.277 62.021 52.114 62.344 51.792 62.667 51.34 62.829 50.921 62.829 50.534V30.011C62.829 29.493 62.667 29.074 62.344 28.752 61.957 28.365 61.505 28.171 60.989 28.171H-.097Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,542.1614,453.2512)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0H60.989C61.44 0 61.892-.162 62.344-.484 62.667-.936 62.829-1.389 62.829-1.839V-21.879C62.829-22.331 62.667-22.783 62.344-23.234 61.892-23.558 61.44-23.718 60.989-23.718H.097C-8.94-23.718-15.489-21.815-19.555-18.007-21.751-16.135-23.364-13.78-24.396-10.939-25.429-8.1-25.945-4.84-25.945-1.162V29.623C-25.945 37.238-23.815 42.886-19.555 46.565-15.489 50.372-8.94 52.277 .097 52.277H60.989C61.57 52.277 62.021 52.114 62.344 51.792 62.667 51.34 62.829 50.921 62.829 50.534V30.011C62.829 29.493 62.667 29.074 62.344 28.752 61.957 28.365 61.505 28.171 60.989 28.171H-.097L0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,643.3979,400.8777)",
    d: "M0 0C.515 0 .951-.179 1.307-.533 1.66-.888 1.839-1.324 1.839-1.839V-74.252C1.839-74.77 1.66-75.205 1.307-75.559 .951-75.915 .515-76.092 0-76.092H-24.881C-25.398-76.092-25.833-75.915-26.187-75.559-26.543-75.205-26.72-74.77-26.72-74.252V-1.839C-26.72-1.324-26.543-.888-26.187-.533-25.833-.179-25.398 0-24.881 0Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,643.3979,400.8777)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C.515 0 .951-.179 1.307-.533 1.66-.888 1.839-1.324 1.839-1.839V-74.252C1.839-74.77 1.66-75.205 1.307-75.559 .951-75.915 .515-76.092 0-76.092H-24.881C-25.398-76.092-25.833-75.915-26.187-75.559-26.543-75.205-26.72-74.77-26.72-74.252V-1.839C-26.72-1.324-26.543-.888-26.187-.533-25.833-.179-25.398 0-24.881 0H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,715.9652,475.1298)",
    d: "M0 0C0-.518-.179-.953-.533-1.307-.888-1.663-1.324-1.839-1.84-1.839H-26.72C-27.237-1.839-27.672-1.663-28.026-1.307-28.382-.953-28.559-.518-28.559 0V51.115H-57.117C-57.634 51.115-58.07 51.292-58.424 51.647-58.779 52.001-58.957 52.437-58.957 52.954V72.413C-58.957 72.928-58.779 73.364-58.424 73.72-58.07 74.073-57.634 74.252-57.117 74.252H27.493C28.01 74.252 28.445 74.073 28.8 73.72 29.155 73.364 29.332 72.928 29.332 72.413V52.954C29.332 52.437 29.155 52.001 28.8 51.647 28.445 51.292 28.01 51.115 27.493 51.115H0Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,715.9652,475.1298)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C0-.518-.179-.953-.533-1.307-.888-1.663-1.324-1.839-1.84-1.839H-26.72C-27.237-1.839-27.672-1.663-28.026-1.307-28.382-.953-28.559-.518-28.559 0V51.115H-57.117C-57.634 51.115-58.07 51.292-58.424 51.647-58.779 52.001-58.957 52.437-58.957 52.954V72.413C-58.957 72.928-58.779 73.364-58.424 73.72-58.07 74.073-57.634 74.252-57.117 74.252H27.493C28.01 74.252 28.445 74.073 28.8 73.72 29.155 73.364 29.332 72.928 29.332 72.413V52.954C29.332 52.437 29.155 52.001 28.8 51.647 28.445 51.292 28.01 51.115 27.493 51.115H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,758.3621,476.00129)",
    d: "M0 0C-.13-.193-.372-.404-.726-.629-1.081-.856-1.421-.968-1.742-.968H-30.01C-30.722-.968-31.252-.677-31.608-.097-31.962 .484-31.979 1.129-31.656 1.839L8.036 74.155C8.163 74.412 8.406 74.639 8.761 74.833 9.115 75.027 9.422 75.124 9.681 75.124H39.498C39.82 75.124 40.142 75.027 40.466 74.833 40.788 74.639 41.014 74.412 41.144 74.155L80.351 1.839C80.738 1.129 80.738 .484 80.351-.097 79.964-.677 79.415-.968 78.705-.968H50.825C50.501-.968 50.179-.856 49.856-.629 49.533-.404 49.307-.193 49.178 0L43.37 10.843H12.779C12.068 10.843 11.536 11.133 11.181 11.714 10.826 12.295 10.843 12.908 11.23 13.553L20.813 31.85C20.942 32.107 21.168 32.317 21.491 32.479 21.814 32.64 22.104 32.722 22.363 32.722H31.656L28.268 39.207H28.365C27.913 39.982 27.557 40.611 27.3 41.095 27.041 41.579 26.783 42.03 26.526 42.45 26.267 42.87 25.977 43.37 25.654 43.951 25.331 44.532 24.912 45.307 24.395 46.275Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,758.3621,476.00129)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C-.13-.193-.372-.404-.726-.629-1.081-.856-1.421-.968-1.742-.968H-30.01C-30.722-.968-31.252-.677-31.608-.097-31.962 .484-31.979 1.129-31.656 1.839L8.036 74.155C8.163 74.412 8.406 74.639 8.761 74.833 9.115 75.027 9.422 75.124 9.681 75.124H39.498C39.82 75.124 40.142 75.027 40.466 74.833 40.788 74.639 41.014 74.412 41.144 74.155L80.351 1.839C80.738 1.129 80.738 .484 80.351-.097 79.964-.677 79.415-.968 78.705-.968H50.825C50.501-.968 50.179-.856 49.856-.629 49.533-.404 49.307-.193 49.178 0L43.37 10.843H12.779C12.068 10.843 11.536 11.133 11.181 11.714 10.826 12.295 10.843 12.908 11.23 13.553L20.813 31.85C20.942 32.107 21.168 32.317 21.491 32.479 21.814 32.64 22.104 32.722 22.363 32.722H31.656L28.268 39.207H28.365C27.913 39.982 27.557 40.611 27.3 41.095 27.041 41.579 26.783 42.03 26.526 42.45 26.267 42.87 25.977 43.37 25.654 43.951 25.331 44.532 24.912 45.307 24.395 46.275L0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1250.7064,453.4449)",
    d: "M0 0H40.466C40.982 0 41.417-.179 41.773-.533 42.127-.888 42.306-1.323 42.306-1.839V-21.685C42.306-22.203 42.127-22.638 41.773-22.992 41.417-23.348 40.982-23.524 40.466-23.524H-44.629C-45.146-23.524-45.581-23.348-45.936-22.992-46.291-22.638-46.468-22.203-46.468-21.685V-2.711C-46.468-2.517-46.404-2.26-46.274-1.936-46.145-1.614-45.984-1.389-45.79-1.258L-4.55 28.946H-44.629C-45.146 28.946-45.581 29.123-45.936 29.478-46.291 29.832-46.468 30.268-46.468 30.785V50.728C-46.468 51.243-46.291 51.679-45.936 52.035-45.581 52.389-45.146 52.567-44.629 52.567H40.466C40.982 52.567 41.417 52.389 41.773 52.035 42.127 51.679 42.306 51.243 42.306 50.728V31.753C42.306 31.172 42.047 30.689 41.531 30.301Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1250.7064,453.4449)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0H40.466C40.982 0 41.417-.179 41.773-.533 42.127-.888 42.306-1.323 42.306-1.839V-21.685C42.306-22.203 42.127-22.638 41.773-22.992 41.417-23.348 40.982-23.524 40.466-23.524H-44.629C-45.146-23.524-45.581-23.348-45.936-22.992-46.291-22.638-46.468-22.203-46.468-21.685V-2.711C-46.468-2.517-46.404-2.26-46.274-1.936-46.145-1.614-45.984-1.389-45.79-1.258L-4.55 28.946H-44.629C-45.146 28.946-45.581 29.123-45.936 29.478-46.291 29.832-46.468 30.268-46.468 30.785V50.728C-46.468 51.243-46.291 51.679-45.936 52.035-45.581 52.389-45.146 52.567-44.629 52.567H40.466C40.982 52.567 41.417 52.389 41.773 52.035 42.127 51.679 42.306 51.243 42.306 50.728V31.753C42.306 31.172 42.047 30.689 41.531 30.301L0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,91.7084,476.9693)",
    d: "M0 0C-12.232 0-21.116 2.513-26.406 7.468L-26.507 7.559C-29.279 9.921-31.347 12.947-32.656 16.552-34.027 20.317-34.72 24.735-34.72 29.687V74.146C-34.72 84.216-31.953 91.712-26.493 96.426L-26.406 96.504C-21.113 101.46-12.23 103.973 0 103.973H87.707V74.937H-3.178L-3.019 28.477H87.709L87.707 0Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,91.7084,476.9693)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C-12.232 0-21.116 2.513-26.406 7.468L-26.507 7.559C-29.279 9.921-31.347 12.947-32.656 16.552-34.027 20.317-34.72 24.735-34.72 29.687V74.146C-34.72 84.216-31.953 91.712-26.493 96.426L-26.406 96.504C-21.113 101.46-12.23 103.973 0 103.973H87.707V74.937H-3.178L-3.019 28.477H87.709L87.707 0H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,974.0623,476.9693)",
    d: "M0 0-.001 69.96-32.85 .129C-32.891 .096-32.946 .053-33.02 0H-56.5C-56.582 .058-56.64 .104-56.682 .137L-89.942 69.261V0H-123.59L-123.591 104.112H-71.229L-44.918 48.397-42.34 54.078C-41.419 56.111-40.494 58.1-39.569 60.041-38.647 61.979-37.667 63.984-36.656 66.002-33.673 72.434-30.6 78.91-27.484 85.328-24.385 91.713-21.417 98.02-18.662 104.075-18.649 104.086-18.633 104.098-18.614 104.112H33.368V0Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,974.0623,476.9693)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0-.001 69.96-32.85 .129C-32.891 .096-32.946 .053-33.02 0H-56.5C-56.582 .058-56.64 .104-56.682 .137L-89.942 69.261V0H-123.59L-123.591 104.112H-71.229L-44.918 48.397-42.34 54.078C-41.419 56.111-40.494 58.1-39.569 60.041-38.647 61.979-37.667 63.984-36.656 66.002-33.673 72.434-30.6 78.91-27.484 85.328-24.385 91.713-21.417 98.02-18.662 104.075-18.649 104.086-18.633 104.098-18.614 104.112H33.368V0H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1104.4861,424.0542)",
    d: "M0 0-50.627 55.439-50.091 55.928 .536 .49Z",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1155.1127,479.4932)",
    d: "M0 0-50.627 55.439-50.091 55.928 .536 .49Z",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1091.4287,498.60929)",
    d: "M0 0-.714 .13 12.968 74.865 13.682 74.734Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1104.9988,424.0774)",
    d: "M0 0-.49 .536 54.949 51.163 55.439 50.627Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1105.1105,423.8778)",
    d: "M0 0-.713 .137 9.39 52.799 10.103 52.662Z",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1104.4031,423.90229)",
    d: "M0 0-19.144 72.392-18.442 72.578 .702 .186Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1104.9171,424.1338)",
    d: "M0 0-.326 .649 47.584 24.742 47.91 24.094Z",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1121.6848,485.8563)",
    d: "M0 0-17.28 61.949-16.581 62.144 .699 .195Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1049.5599,474.7042)",
    d: "M0 0-.49 .536 54.949 51.163 55.439 50.627Z",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1114.1848,487.7471)",
    d: "M0 0C-1.465 4.335 .862 9.037 5.197 10.503 9.532 11.968 14.234 9.641 15.699 5.306 17.165 .97 14.838-3.732 10.503-5.197 6.167-6.662 1.465-4.335 0 0",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1145.409,485.6824)",
    d: "M0 0C-4.358 4.772-4.022 12.174 .75 16.532 5.522 20.89 12.924 20.555 17.282 15.782 21.641 11.01 21.305 3.608 16.532-.75 11.76-5.108 4.358-4.772 0 0",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1046.7185,379.8815)",
    d: "M0 0C-4.928 5.397-4.548 13.767 .848 18.695 6.245 23.623 14.615 23.244 19.543 17.847 24.472 12.45 24.092 4.08 18.695-.848 13.298-5.776 4.928-5.397 0 0",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1042.7546,467.2521)",
    d: "M0 0C3.968 3.623 10.121 3.344 13.745-.624 17.368-4.591 17.089-10.745 13.121-14.368 9.153-17.992 3-17.712-.624-13.745-4.247-9.777-3.968-3.623 0 0",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1149.3978,365.8065)",
    d: "M0 0C5.19 4.74 13.24 4.374 17.979-.816 22.719-6.006 22.354-14.055 17.163-18.795 11.973-23.535 3.924-23.169-.816-17.979-5.555-12.789-5.19-4.74 0 0",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1149.3978,365.8065)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C5.19 4.74 13.24 4.374 17.979-.816 22.719-6.006 22.354-14.055 17.163-18.795 11.973-23.535 3.924-23.169-.816-17.979-5.555-12.789-5.19-4.74 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1076.7771,354.40229)",
    d: "M0 0C-1.649 4.878 .97 10.17 5.848 11.819 10.727 13.467 16.018 10.849 17.667 5.971 19.315 1.092 16.697-4.199 11.819-5.848 6.94-7.497 1.649-4.878 0 0",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1076.7771,354.40229)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C-1.649 4.878 .97 10.17 5.848 11.819 10.727 13.467 16.018 10.849 17.667 5.971 19.315 1.092 16.697-4.199 11.819-5.848 6.94-7.497 1.649-4.878 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1082.1847,496.8393)",
    d: "M0 0C.942 4.908 5.684 8.124 10.592 7.182 15.5 6.241 18.716 1.498 17.774-3.41 16.832-8.318 12.09-11.533 7.182-10.592 2.274-9.65-.942-4.908 0 0",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1105.9697,369.4426)",
    d: "M0 0C.942 4.908 5.684 8.124 10.592 7.182 15.5 6.241 18.716 1.498 17.774-3.41 16.832-8.318 12.09-11.533 7.182-10.592 2.274-9.65-.942-4.908 0 0",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1151.2131,393.691)",
    d: "M0 0C3.374 1.14 7.034-.671 8.174-4.045 9.315-7.419 7.504-11.079 4.13-12.219 .755-13.36-2.904-11.549-4.045-8.174-5.185-4.8-3.374-1.14 0 0",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1157.3475,434.2687)",
    d: "M0 0-52.662 10.103-52.525 10.816 .137 .713Z",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1104.7089,424.1696)",
    d: "M0 0-75.077 9.431-74.987 10.151 .09 .72Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1032.4678,442.08799)",
    d: "M0 0-.174 .705 72.199 18.631 72.373 17.926Z",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1030.5258,436.2469)",
    d: "M0 0C3.031 1.024 6.319-.602 7.344-3.634 8.368-6.665 6.741-9.953 3.71-10.977 .679-12.002-2.609-10.375-3.634-7.344-4.658-4.312-3.031-1.024 0 0",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1054.692,442.5636)",
    d: "M0 0C3.031 1.024 6.319-.602 7.344-3.634 8.368-6.665 6.741-9.953 3.71-10.977 .679-12.002-2.609-10.375-3.634-7.344-4.658-4.312-3.031-1.024 0 0",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1104.785,424.17109)",
    d: "M0 0-.062 .723 74.482 7.112 74.544 6.388Z",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1184.2882,410.4375)",
    d: "M0 0C3.523-.676 5.831-4.08 5.155-7.602 4.479-11.125 1.075-13.433-2.447-12.757-5.97-12.081-8.278-8.678-7.602-5.155-6.927-1.632-3.523 .676 0 0",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1063.0335,493.2233)",
    d: "M0 0-.621 .377 41.41 69.602 42.031 69.225Z",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1061.6714,489.7138)",
    d: "M0 0C1.902 .643 3.965-.378 4.608-2.28 5.251-4.182 4.23-6.245 2.328-6.888 .426-7.531-1.637-6.51-2.28-4.608-2.923-2.706-1.902-.643 0 0",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1105.0776,423.9737)",
    d: "M0 0-.647 .329 36.119 72.721 36.766 72.392Z",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1160.3345,422.876)",
    d: "M0 0C6.52-1.251 10.791-7.55 9.54-14.07 8.29-20.59 1.99-24.861-4.529-23.61-11.049-22.359-15.321-16.06-14.07-9.54-12.819-3.021-6.52 1.251 0 0",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1107.0602,455.57319)",
    d: "M0 0-2.668 31.733-1.944 31.794 .724 .061Z",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1105.9577,451.2099)",
    d: "M0 0C2.393 .809 4.988-.476 5.797-2.868 6.606-5.261 5.322-7.857 2.929-8.666 .536-9.474-2.06-8.19-2.869-5.797-3.677-3.404-2.393-.809 0 0",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1140.3058,347.82337)",
    d: "M0 0C1.985 .671 4.137-.394 4.808-2.379 5.479-4.364 4.414-6.516 2.429-7.187 .444-7.858-1.708-6.793-2.379-4.808-3.05-2.823-1.985-.671 0 0",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1104.8635,424.1554)",
    d: "M0 0-.219 .692 76.902 25.11 77.121 24.418Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1180.6382,395.7311)",
    d: "M0 0C2.022 .683 4.214-.402 4.898-2.423 5.581-4.445 4.496-6.638 2.474-7.321 .453-8.004-1.74-6.919-2.423-4.898-3.107-2.876-2.022-.683 0 0",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1176.3954,463.0693)",
    d: "M0 0-71.814 38.941-71.468 39.579 .346 .638Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1175.5681,459.79069)",
    d: "M0 0C1.635 .552 3.407-.325 3.96-1.959 4.512-3.594 3.635-5.367 2-5.919 .366-6.472-1.407-5.594-1.959-3.96-2.512-2.325-1.635-.552 0 0",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1145.6575,453.03959)",
    d: "M0 0C1.911 .646 3.984-.38 4.63-2.291 5.276-4.202 4.251-6.276 2.339-6.922 .428-7.567-1.645-6.542-2.291-4.63-2.937-2.719-1.911-.646 0 0",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1145.6575,453.03959)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C1.911 .646 3.984-.38 4.63-2.291 5.276-4.202 4.251-6.276 2.339-6.922 .428-7.567-1.645-6.542-2.291-4.63-2.937-2.719-1.911-.646 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1139.4916,493.33329)",
    d: "M0 0C1.911 .646 3.984-.38 4.63-2.291 5.276-4.202 4.25-6.276 2.339-6.922 .428-7.567-1.645-6.542-2.291-4.63-2.937-2.719-1.911-.646 0 0",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1139.4916,493.33329)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C1.911 .646 3.984-.38 4.63-2.291 5.276-4.202 4.25-6.276 2.339-6.922 .428-7.567-1.645-6.542-2.291-4.63-2.937-2.719-1.911-.646 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1031.3816,405.49119)",
    d: "M0 0C4.908-.942 8.124-5.684 7.182-10.592 6.241-15.5 1.498-18.716-3.41-17.774-8.318-16.832-11.533-12.09-10.592-7.182-9.65-2.274-4.908 .942 0 0",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1056.7101,448.3767)",
    d: "M0 0-.326 .649 47.881 24.892 48.207 24.243Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1104.4354,423.9831)",
    d: "M0 0-15.106 27.719-14.469 28.067 .637 .347Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1087.9547,391.0806)",
    d: "M0 0C2.767 .935 5.767-.55 6.703-3.316 7.638-6.083 6.153-9.084 3.386-10.019 .619-10.954-2.381-9.469-3.317-6.703-4.252-3.936-2.767-.935 0 0",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1061.759,421.9772)",
    d: "M0 0C2.169 .733 4.522-.431 5.255-2.6 5.988-4.769 4.824-7.122 2.655-7.855 .486-8.588-1.867-7.424-2.6-5.255-3.333-3.086-2.169-.733 0 0",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1061.759,421.9772)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C2.169 .733 4.522-.431 5.255-2.6 5.988-4.769 4.824-7.122 2.655-7.855 .486-8.588-1.867-7.424-2.6-5.255-3.333-3.086-2.169-.733 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1063.1045,426.2673)",
    d: "M0 0-.036 .725 41.631 2.82 41.668 2.095Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1104.6,424.138)",
    d: "M0 0-68.561 32.138-68.253 32.795 .308 .657Z",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1098.9467,429.1127)",
    d: "M0 0C-2.929 3.207-2.703 8.182 .504 11.111 3.711 14.039 8.686 13.814 11.615 10.606 14.544 7.399 14.318 2.425 11.111-.504 7.903-3.433 2.929-3.207 0 0",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1098.9467,429.1127)",
    strokeWidth: 0.219,
    strokeLinecap: "butt",
    strokeMiterlimit: 10,
    strokeLinejoin: "miter",
    fill: "none",
    stroke: "#e12320",
    d: "M0 0C-2.929 3.207-2.703 8.182 .504 11.111 3.711 14.039 8.686 13.814 11.615 10.606 14.544 7.399 14.318 2.425 11.111-.504 7.903-3.433 2.929-3.207 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1034.5021,386.669)",
    d: "M0 0C2.763 .934 5.76-.549 6.694-3.312 7.628-6.075 6.145-9.072 3.382-10.006 .619-10.94-2.378-9.457-3.312-6.694-4.246-3.931-2.763-.934 0 0",
    fill: "#00a551"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1146.6044,456.787)",
    d: "M0 0-42.073 32.691-41.628 33.264 .446 .573Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1140.3353,496.9544)",
    d: "M0 0-35.907 72.985-35.255 73.305 .651 .32Z",
    fill: "#e12320"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,191.1871,542.95608)",
    d: "M0 0V16.462H5.557V.487C5.557-1.354 6.426-2.917 9.377-2.917 12.329-2.917 13.198-1.354 13.198 .487V16.462H18.754V0C18.754-5.209 14.726-8.334 9.377-8.334 4.029-8.334 0-5.209 0 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,238.2453,550.8044)",
    d: "M0 0H-5.556V14.135L-11.843 3.82H-12.467L-18.753 14.135V0H-24.31V24.31H-18.753L-12.155 13.51-5.556 24.31H0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,254.9852,541.77468)",
    d: "M0 0-2.848 8.925-5.695 0ZM1.667-5.209H-7.362L-8.578-9.03H-14.655L-6.39 15.28H.695L8.96-9.03H2.882Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,877.607)",
    d: "M280.269 326.803H274.712V351.113H280.269Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,303.5368,526.49429)",
    d: "M0 0V-24.31H-4.167L-13.544-11.113V-24.31H-19.101V0H-14.933L-5.556-13.197V0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,877.607)",
    d: "M313.263 326.803H307.706V351.113H313.263Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,316.3889,538.6488)",
    d: "M0 0C0 7.154 5.313 12.641 12.641 12.641 17.052 12.641 20.941 10.453 23.059 7.015L18.267 4.237C17.19 6.112 15.106 7.223 12.641 7.223 8.334 7.223 5.556 4.341 5.556 0 5.556-4.342 8.334-7.224 12.641-7.224 15.106-7.224 17.225-6.113 18.267-4.238L23.059-7.016C20.976-10.453 17.087-12.641 12.641-12.641 5.313-12.641 0-7.155 0 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,877.607)",
    d: "M347.61 326.803H342.05299V351.113H347.61Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,364.3492,541.77468)",
    d: "M0 0-2.848 8.925-5.695 0ZM1.667-5.209H-7.362L-8.578-9.03H-14.655L-6.39 15.28H.695L8.96-9.03H2.882Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,389.9808,531.8428)",
    d: "M0 0H-6.251V-18.962H-11.808V0H-18.058V5.348H0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,877.607)",
    d: "M397.969 326.803H392.412V351.113H397.969Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,400.0528,526.49429)",
    d: "M0 0H6.078L11.461-17.886 16.843 0H22.921L15.003-24.31H7.918Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,436.2402,541.77468)",
    d: "M0 0-2.848 8.925-5.695 0ZM1.667-5.209H-7.362L-8.578-9.03H-14.655L-6.39 15.28H.695L8.96-9.03H2.882Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,470.2059,545.45596)",
    d: "M0 0V-5.348H-14.239V18.962H-8.682V0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,877.607)",
    d: "M478.194 326.803H472.637V351.113H478.194Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,498.545,538.6488)",
    d: "M0 0C0 4.167-2.639 6.806-6.459 6.806H-10.626V-6.807H-6.459C-2.639-6.807 0-4.168 0 0M5.348 0C5.348-6.877 .243-12.156-6.459-12.156H-16.184V12.155H-6.459C.243 12.155 5.348 6.876 5.348 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,522.3006,545.45596)",
    d: "M0 0V-5.348H-15.281V18.962H-.174V13.613H-9.724V9.585H-1.042V4.306H-9.724V0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,530.9836,537.9543)",
    d: "M0 0H4.167C5.695 0 6.945 1.354 6.945 3.125 6.945 4.896 5.695 6.251 4.167 6.251H0ZM2.639-4.863H0V-12.85H-5.557V11.46H4.167C8.786 11.46 12.502 7.744 12.502 3.125 12.502 .138 10.696-2.57 8.022-3.925L13.197-12.85H7.223Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,559.3564,541.77468)",
    d: "M0 0-2.848 8.925-5.695 0ZM1.667-5.209H-7.362L-8.578-9.03H-14.655L-6.39 15.28H.695L8.96-9.03H2.882Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,586.5847,538.6488)",
    d: "M0 0C0 4.167-2.639 6.806-6.459 6.806H-10.626V-6.807H-6.459C-2.639-6.807 0-4.168 0 0M5.348 0C5.348-6.877 .243-12.156-6.459-12.156H-16.184V12.155H-6.459C.243 12.155 5.348 6.876 5.348 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,606.7634,541.77468)",
    d: "M0 0-2.848 8.925-5.695 0ZM1.667-5.209H-7.362L-8.578-9.03H-14.655L-6.39 15.28H.695L8.96-9.03H2.882Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,638.6456,534.82949)",
    d: "M0 0C0 1.772-1.251 3.126-2.952 3.126H-6.598V-3.125H-2.952C-1.251-3.125 0-1.771 0 0M5.556 0C5.556-4.618 1.84-8.334-2.952-8.334H-6.598V-15.975H-12.156V8.335H-2.952C1.84 8.335 5.556 4.619 5.556 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,662.2621,545.45596)",
    d: "M0 0V-5.348H-15.281V18.962H-.174V13.613H-9.724V9.585H-1.042V4.306H-9.724V0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,679.626,545.45596)",
    d: "M0 0V-5.348H-14.239V18.962H-8.682V0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,699.3527,538.6488)",
    d: "M0 0C0 4.341-3.126 7.223-7.084 7.223-11.044 7.223-14.169 4.341-14.169 0-14.169-4.342-11.044-7.224-7.084-7.224-3.126-7.224 0-4.342 0 0M-19.726 0C-19.726 7.154-14.065 12.641-7.084 12.641-.104 12.641 5.556 7.154 5.556 0 5.556-7.155-.104-12.641-7.084-12.641-14.065-12.641-19.726-7.155-19.726 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,728.8731,534.82949)",
    d: "M0 0C0 1.772-1.251 3.126-2.952 3.126H-6.598V-3.125H-2.952C-1.251-3.125 0-1.771 0 0M5.556 0C5.556-4.618 1.84-8.334-2.952-8.334H-6.598V-15.975H-12.156V8.335H-2.952C1.84 8.335 5.556 4.619 5.556 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,742.7654,537.9543)",
    d: "M0 0H4.167C5.695 0 6.945 1.354 6.945 3.125 6.945 4.896 5.695 6.251 4.167 6.251H0ZM2.639-4.863H0V-12.85H-5.557V11.46H4.167C8.786 11.46 12.502 7.744 12.502 3.125 12.502 .138 10.696-2.57 8.022-3.925L13.197-12.85H7.223Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,776.9041,538.6488)",
    d: "M0 0C0 4.341-3.126 7.223-7.084 7.223-11.044 7.223-14.169 4.341-14.169 0-14.169-4.342-11.044-7.224-7.084-7.224-3.126-7.224 0-4.342 0 0M-19.726 0C-19.726 7.154-14.065 12.641-7.084 12.641-.104 12.641 5.556 7.154 5.556 0 5.556-7.155-.104-12.641-7.084-12.641-14.065-12.641-19.726-7.155-19.726 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,782.1144,546.5677)",
    d: "M0 0 4.827 2.779C5.591 1.424 6.39 .695 8.265 .695 10.696 .695 11.425 2.084 11.425 3.577V20.073H16.982V3.577C16.982-1.771 13.232-4.723 8.23-4.723 4.376-4.723 1.597-3.091 0 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,818.3724,545.45596)",
    d: "M0 0V-5.348H-15.281V18.962H-.174V13.613H-9.724V9.585H-1.042V4.306H-9.724V0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,820.2831,538.6488)",
    d: "M0 0C0 7.154 5.313 12.641 12.641 12.641 17.052 12.641 20.941 10.453 23.059 7.015L18.267 4.237C17.19 6.112 15.106 7.223 12.641 7.223 8.334 7.223 5.556 4.341 5.556 0 5.556-4.342 8.334-7.224 12.641-7.224 15.106-7.224 17.225-6.113 18.267-4.238L23.059-7.016C20.976-10.453 17.087-12.641 12.641-12.641 5.313-12.641 0-7.155 0 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,862.27,531.8428)",
    d: "M0 0H-6.251V-18.962H-11.808V0H-18.058V5.348H0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,881.9977,538.6488)",
    d: "M0 0C0 4.341-3.126 7.223-7.084 7.223-11.044 7.223-14.169 4.341-14.169 0-14.169-4.342-11.044-7.224-7.084-7.224-3.126-7.224 0-4.342 0 0M-19.726 0C-19.726 7.154-14.065 12.641-7.084 12.641-.104 12.641 5.556 7.154 5.556 0 5.556-7.155-.104-12.641-7.084-12.641-14.065-12.641-19.726-7.155-19.726 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,923.6727,550.8044)",
    d: "M0 0H-5.556V14.135L-11.843 3.82H-12.468L-18.753 14.135V0H-24.31V24.31H-18.753L-12.155 13.51-5.556 24.31H0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,946.5251,538.6488)",
    d: "M0 0C0 4.341-3.126 7.223-7.084 7.223-11.044 7.223-14.17 4.341-14.17 0-14.17-4.342-11.044-7.224-7.084-7.224-3.126-7.224 0-4.342 0 0M-19.726 0C-19.726 7.154-14.065 12.641-7.084 12.641-.104 12.641 5.556 7.154 5.556 0 5.556-7.155-.104-12.641-7.084-12.641-14.065-12.641-19.726-7.155-19.726 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,969.9678,545.45596)",
    d: "M0 0V-5.348H-16.67V-1.042L-7.362 13.613H-16.496V18.962H-.174V14.655L-9.481 0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,985.6644,541.77468)",
    d: "M0 0-2.848 8.925-5.695 0ZM1.667-5.209H-7.362L-8.578-9.03H-14.655L-6.39 15.28H.695L8.96-9.03H2.882Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1021.0192,550.8044)",
    d: "M0 0H-5.556V14.135L-11.843 3.82H-12.468L-18.753 14.135V0H-24.31V24.31H-18.753L-12.155 13.51-5.556 24.31H0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1037.6896,543.268)",
    d: "M0 0C0 1.354-.902 2.327-2.292 2.327H-6.945V-2.327H-2.292C-.902-2.327 0-1.354 0 0M-6.945 11.564V7.258H-2.987C-1.736 7.258-.868 8.161-.868 9.411-.868 10.661-1.701 11.564-2.987 11.564ZM5.557-.417C5.557-4.724 2.05-7.536-2.292-7.536H-12.502V16.774H-2.987C1.251 16.774 4.689 14.03 4.689 9.829 4.689 7.814 3.89 6.216 2.57 5.07 4.376 3.925 5.557 2.049 5.557-.417",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,0,877.607)",
    d: "M1051.582 326.803H1046.025V351.113H1051.582Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1069.0502,545.6993)",
    d: "M0 0-3.507 3.716 .487 7.258 4.376 3.126C5.001 4.237 5.383 5.557 5.383 7.05 5.383 11.391 2.257 14.274-1.701 14.274-5.661 14.274-8.786 11.391-8.786 7.05-8.786 2.708-5.661-.174-1.701-.174-1.111-.174-.555-.104 0 0M8.161-.903 10.593-3.473 6.598-7.015 3.994-4.271C2.292-5.105 .348-5.591-1.701-5.591-8.682-5.591-14.342-.104-14.342 7.05-14.342 14.204-8.682 19.692-1.701 19.692 5.279 19.692 10.939 14.204 10.939 7.05 10.939 3.994 9.898 1.25 8.161-.903",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1082.9435,542.95608)",
    d: "M0 0V16.462H5.557V.487C5.557-1.354 6.426-2.917 9.377-2.917 12.329-2.917 13.198-1.354 13.198 .487V16.462H18.754V0C18.754-5.209 14.726-8.334 9.377-8.334 4.029-8.334 0-5.209 0 0",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1120.973,545.45596)",
    d: "M0 0V-5.348H-15.281V18.962H-.174V13.613H-9.724V9.585H-1.042V4.306H-9.724V0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1147.0199,545.45596)",
    d: "M0 0V-5.348H-14.239V18.962H-8.682V0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1168.5519,526.49429)",
    d: "M0 0V-24.31H-4.167L-13.544-11.113V-24.31H-19.101V0H-14.933L-5.556-13.197V0Z",
    fill: "#58595b"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,-1,1196.7876,539.3434)",
    d: "M0 0C0-7.432-5.175-11.947-11.982-11.947-19.622-11.947-25.109-6.321-25.109 .66-25.109 7.709-19.518 13.336-12.364 13.336-7.71 13.336-3.786 11.044-1.737 7.779L-6.46 5.07C-7.467 6.668-9.655 7.918-12.399 7.918-16.496 7.918-19.553 4.896-19.553 .625-19.553-3.508-16.636-6.53-11.912-6.53-8.683-6.53-6.564-5.106-5.696-2.779H-12.19V2.084H0Z",
    fill: "#58595b"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHrBlueTr);
export default __webpack_public_path__ + "static/media/logo-hr-blue-tr.45c3d9a673f4aa254e5a0b11e7f5d02d.svg";
export { ForwardRef as ReactComponent };